import getCounselList from "./getCounselList";
import getCounsel from "./getCounsel";
import changeStatus from "./changeStatus";
import deleteCounsel from "./deleteCounsel";

export default { getCounselList, getCounsel, changeStatus, deleteCounsel };
